module.exports = JBrowseExports["@jbrowse/core/Plugin"];